module.exports = __webpack_public_path__ + "static/20943443-0bfa2d94304df68311adb55131824deb.jpg";